import {getSubdomain } from '../utils/helper';

export let BASE_API_URL = '';
export let ANALYTICS_API_URL = '';

 if (getSubdomain() == 'localhost'){
     ANALYTICS_API_URL = 'http://localhost:3000/posts';
     BASE_API_URL = 'http://localhost:3303/api';
 }
 else {
     ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
     BASE_API_URL = `${window.location.origin}/api`
 }
 


// WEBPACK FOOTER //
// ./src/constants/constants.js